const text = (value) => typeof value === "string" || typeof value === "number" ? String(value).trim() : "";

export function corporateScanPresentation(result = {}) {
  const extracted = result.extracted || result.extractedData || {};
  const fields = [
    ["Document type", "semantic_document_type", "identified_document_type", "document_type", "documentType", "visible_document_title"],
    ["Company name", "company_name", "companyName", "name"],
    ["Registration number", "registration_number", "registrationNumber"],
    ["Licence number", "licence_number", "license_number", "licenceNumber", "licenseNumber"],
    ["Incorporation date", "incorporation_date", "incorporationDate"],
    ["Registered address", "registered_address", "registeredAddress"],
    ["Incorporation country", "jurisdiction_country_iso2", "jurisdiction_country", "country"],
    ["Issue date", "issue_date", "issueDate"],
    ["Expiry date", "expiry_date", "expiryDate"],
    ["Issuer country", "issuer_country_iso2", "issuer_country", "issuerCountry"],
    ["Entity status", "entity_status", "entityStatus"],
    ["Legal form", "legal_form", "legalForm"],
    ["Email", "contact_email", "contactEmail", "email"],
    ["Phone", "contact_phone", "contactPhone", "phone"],
  ];
  const rows = fields.flatMap(([label, ...keys]) => {
    const value = keys.map((key) => text(extracted[key])).find(Boolean);
    return value ? [{ label, value }] : [];
  });
  const status = text(result.overallStatus || result.status);
  const pending = ["pending", "processing", "running"].includes(status);
  const incomplete = result.status === "failed" || result.assessmentStatus === "not_assessed" ||
    ["not_assessed", "manual_review"].includes(status) || result.scanType === "unsupported";
  return {
    rows,
    stage: pending ? "Scanning document…" : incomplete ? "Automated check incomplete." : "Scan complete.",
    message: pending ? "The document is still being processed." :
      incomplete ? (rows.length ? "Details extracted. Automated comparison could not be completed. Please review the document manually." :
        "The automated check could not be completed. Please review the document manually.") :
      rows.length ? "Extracted document details" : "No document details could be extracted. Please review the document manually.",
  };
}

export function attachmentScanResult(file, docKey) {
  // A file can have more than one scan; select the result for this requirement.
  const field = { reg: "corporateDocumentCheck", poa: "proofOfAddressCheck", id: "documentDataConsistencyCheck" }[docKey];
  if (field) return file?.[field] || file?.documentClassificationCheck || null;
  return file?.documentDataConsistencyCheck || file?.proofOfAddressCheck ||
    file?.corporateDocumentCheck || file?.documentClassificationCheck || null;
}
